import ApplicationSerializer from 'eflex/serializers/application';

export default class BackupConfigSerializer extends ApplicationSerializer {
  attrs = {
    days: {
      embedded: 'always',
    },
  };
}
